import Component from 'flarum/common/Component';
import IndexPage from 'flarum/forum/components/IndexPage';
import SelectDropdown from 'flarum/common/components/SelectDropdown';

export default class ForumNav extends Component {
  view() {
    return (
      <div className="BlogForumNav BlogSideWidget">
      </div>
    );
  }

  navItems() {
    return IndexPage.prototype.navItems();
  }
}
